import React, { FunctionComponent, ReactNode, useState } from 'react';

import clsx from 'clsx';

import { CloseIcon } from '@components/icons';

import styles from './QuizBlock.module.scss';

import { Button } from '../Button/Button';

type QuizBlockProps = {
    className?: string;
    mainClassName?: string;
    textWrapperClassName?: string;
    link: string;
    heading: string;
    description: ReactNode;
    isSmall?: boolean;
    onComplete?: () => void;
    onDismiss?: () => void;
};

export const QuizBlock: FunctionComponent<QuizBlockProps> = ({
    className,
    mainClassName,
    textWrapperClassName,
    link,
    heading,
    description,
    isSmall = false,
    onComplete,
    onDismiss,
}) => {
    const [isVisible, setVisibility] = useState(true);

    if (!isVisible) return null;

    const handleComplete = () => {
        onComplete?.();
        setVisibility(false);
    };

    const handleDismiss = () => {
        onDismiss?.();
        setVisibility(false);
    };

    return (
        <div
            className={clsx(className, styles.root, isSmall && styles.isSmall)}
            data-testid="quiz-block"
        >
            <div className={clsx(styles.main, mainClassName)}>
                <div className={clsx(styles.textWrapper, textWrapperClassName)}>
                    <span className={styles.heading}>{heading}</span>
                    <span className={styles.text}>{description}</span>
                </div>
                <Button
                    className={clsx(styles.quizButton, styles.desktop)}
                    variant="white"
                    link={link}
                    target="_blank"
                    onClick={handleComplete}
                    data-testid="quiz-complete-btn"
                >
                    Пройти опрос
                </Button>
            </div>

            <Button
                target="_blank"
                className={styles.quizButton}
                variant="white"
                link={link}
                onClick={handleComplete}
                data-testid="quiz-complete-btn-mobile"
            >
                Пройти опрос
            </Button>

            <button
                type="button"
                className={clsx(styles.removeButton, styles.desktop)}
                onClick={handleDismiss}
                data-testid="quiz-dismiss-btn"
            >
                <CloseIcon className={styles.crossIcon} />
            </button>
        </div>
    );
};
